export default __webpack_public_path__ + "static/media/illustration-1.a7c21ae2.svg";